export function buildConfig() {
  return {
    apiURL:
      "https://7fvz0fq780.execute-api.us-east-1.amazonaws.com/production/layers",
    environment: "PRODUCTION",
  };
}
